import { useEffect, useState } from "react";

/** How many chapters the whole book has, for the debug readout. */
export function useBookChapterCount(bookId: string | undefined): number | undefined {
  const [count, setCount] = useState<number>();
  useEffect(() => {
    if (bookId === undefined) {
      return;
    }
    let live = true;
    void fetch(`/book-data/${bookId}/book.json`)
      .then((response) => response.json() as Promise<{ chapters?: unknown[] }>)
      .then((summary) => {
        if (live && Array.isArray(summary.chapters)) {
          setCount(summary.chapters.length);
        }
      })
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [bookId]);
  return count;
}
